export default __webpack_public_path__ + "media/cloud_graphic.bd936ada.svg";